import queryClient from '../../../../ReactQuery/client';
import useToastedMutation from '../../../../ReactQuery/useToastedMutation';
import { post } from '../../../../redux/api';
import type { CancelOrganizationDeletionResponse } from '../../../../../shared/types/routes/internalTools/orgDeletion';
import type { QueryResponse } from '../../../../ReactQuery/useQuery';

import { ORG_DELETIONS_QUERY_KEY } from './useGetOrgDeletions';

function cancelOrgDeletion(id: number): Promise<QueryResponse<CancelOrganizationDeletionResponse>> {
  return post<Record<string, never>, CancelOrganizationDeletionResponse>(
    `/api/internal-tools/organization-deletions/${id}/cancel`,
    {},
  );
}

/**
 * Cancels a SCHEDULED org deletion. The server refuses one that has started or finished.
 */
export function useCancelOrgDeletion() {
  return useToastedMutation({
    mutationFn: cancelOrgDeletion,
    successToastMessage: 'Organization deletion cancelled.',
    errorToastMessage: 'Failed to cancel the organization deletion.',
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ORG_DELETIONS_QUERY_KEY });
    },
  });
}
